import { useContext } from "react";
import PanelManagementContext from "../context/PanelManagementContext";
import FilterFieldState from "../types/FilterFieldState";
import FilterGroupState from "../types/FilterGroupState";

export default function useFilterGroup(id: string) {
  const { filterGroupStates, setFilterGroups } = useContext(
    PanelManagementContext,
  );

  return {
    ...filterGroupStates[id],
    setFilterField: (filterFieldState: FilterFieldState, index: number = 0) => {
      setFilterGroups((prevFilterGroups) => {
        const updatedGroupDefinition = prevFilterGroups[id]
          ? { ...prevFilterGroups[id] }
          : {};

        if (!updatedGroupDefinition.filterFieldStates) {
          updatedGroupDefinition.filterFieldStates = [];
        }
        updatedGroupDefinition.filterFieldStates[index] = filterFieldState;

        return { ...prevFilterGroups, [id]: updatedGroupDefinition };
      });
    },
    setFilterGroup: (filterGroupState: Partial<FilterGroupState>) => {
      setFilterGroups((prevStates) => {
        const updatedStates = { ...prevStates };
        if (updatedStates[id] === undefined) updatedStates[id] = {};

        updatedStates[id] = { ...updatedStates[id], ...filterGroupState };

        return updatedStates;
      });
    },
    deleteFilterField: (index: number = 0) => {
      setFilterGroups((prevFilterGroups) => {
        if (prevFilterGroups[id]?.filterFieldStates === undefined)
          return prevFilterGroups;

        const updated = { ...prevFilterGroups };
        updated[id] = {
          ...updated[id],
          filterFieldStates: updated[id]?.filterFieldStates?.filter(
            (_, i) => i !== index,
          ),
        };

        return updated;
      });
    },
    getFilterCount: () => {
      const numFilters =
        (filterGroupStates[id]?.filterFieldStates &&
          filterGroupStates[id].filterFieldStates?.[0].answer?.length) ||
        0;
      return numFilters;
    },
  };
}
